var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import LoadingContext from "./contexts/Loading";
import { RouterManager } from "./routes/RouterManager";
import { QueryClientProvider, QueryClientProvider as QueryClientProviderV5, QueryClient as QueryClientV5, } from "@tanstack/react-query";
import { queryClient } from "./services/queryClient";
import { StepperControlProvider } from "./contexts/StepperControlContext";
import { Toaster } from "react-hot-toast";
export var App = function () {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var queryClientV5 = new QueryClientV5({
        defaultOptions: {
            queries: {
                retry: 1,
                refetchOnWindowFocus: false,
                retryDelay: 1000,
            },
        },
    });
    return (_jsx(LoadingContext.Provider, __assign({ value: {
            isLoading: isLoading,
            setIsLoading: setIsLoading,
        } }, { children: _jsx(StepperControlProvider, { children: _jsx(QueryClientProviderV5, __assign({ client: queryClientV5 }, { children: _jsx(QueryClientProvider, __assign({ client: queryClient }, { children: _jsxs(_Fragment, { children: [_jsx(RouterManager, {}), _jsx(Toaster, { position: "bottom-center" })] }) })) })) }) })));
};
